// Tailwind replacement for the MUI Tabs used across the destinations
// section. Two modes: a segmented pill group (few options — the Pricing
// billing-toggle idiom) and a horizontally scrolling chip row (many
// options, e.g. the region filter).
export default function JournalTabs({
  options,
  value,
  onChange,
  scroll,
  ariaLabel,
  className = '',
}) {
  const chip = (option, i) => {
    const active = value === i;
    const label =
      typeof option === 'string' ? option : option.label || option.title;
    const count = typeof option === 'object' ? option.count : undefined;
    return (
      <button
        key={label}
        type="button"
        role="tab"
        aria-selected={active}
        onClick={() => onChange(i)}
        className={`tw-whitespace-nowrap tw-rounded-full tw-border-0 tw-cursor-pointer tw-px-4 tw-py-2 tw-font-mono tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-[0.18em] tw-transition-colors ${
          active
            ? 'tw-bg-primary-600 tw-text-white'
            : `tw-text-[#5F6F69] dark:tw-text-[#93A69E] hover:tw-text-primary-700 dark:hover:tw-text-primary-300 ${
                scroll
                  ? 'tw-bg-white dark:tw-bg-[#15231E] tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F]'
                  : 'tw-bg-transparent'
              }`
        }`}
      >
        {label}
        {count !== undefined && (
          <span className="tw-ml-1.5 tw-opacity-60">{count}</span>
        )}
      </button>
    );
  };

  if (scroll)
    return (
      <div
        role="tablist"
        aria-label={ariaLabel}
        className={`tw-flex tw-gap-2 tw-overflow-x-auto tw-pb-2 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden ${className}`}
      >
        {options.map(chip)}
      </div>
    );

  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={`tw-inline-flex tw-max-w-full tw-items-center tw-gap-0.5 tw-overflow-x-auto tw-rounded-full tw-border tw-border-solid tw-border-[#E7E0CF] dark:tw-border-[#26382F] tw-bg-white dark:tw-bg-[#15231E] tw-p-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:tw-hidden ${className}`}
    >
      {options.map(chip)}
    </div>
  );
}
